import { positionFill } from './shared-cell-style';

export const iconStyles = {
  root: {
    position: 'relative',
    top: 3,
    marginLeft: 12,
    marginRight: 5,
  },
};

export const videoSvgIconStyles = {
  ...iconStyles,
  root: {
    ...iconStyles.root,
    top: 5,
    width: 15,
    opacity: 0.8,
  },
};

export const getFolderGridCellStyle = (components, { palette = {} } = {}) => ({
  folderGridCellContainer: {
    ...positionFill,

    display: 'flex',
    flexWrap: 'nowrap',
    padding: 12,
    boxSizing: 'border-box',

    '& .folder-grid-cell-content': {
      display: 'flex',
      flexDirection: 'row',
      flexGrow: 1,
      flexShrink: 1,

      justifyContent: 'flex-start',
      alignItems: 'center',
      background: palette.white,
      padding: 16,
      cursor: 'pointer',

      borderRadius: 6,
      ...positionFill,

      '& .folder-thumbnail': {
        display: 'flex',
        flexGrow: 0,
        flexShrink: 0,
        marginRight: 16,
      },

      '& .folder-info': {
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        flexShrink: 1,
        justifyContent: 'space-between',
        height: '100%',
        paddingTop: 6,

        overflow: 'hidden',
        whiteSpace: 'nowrap',

        '& .folder-name': {
          fontStyle: 'normal',
          fontWeight: 600,
          fontSize: 12,
          lineHeight: '16px',
          // color: palette.neutralSecondary,

          '& .highlighted-text': {
            backgroundColor: palette.yellowLight,
          },
        },

        '& .folder-newlabel-counting': {
          display: 'flex',
          flexDirection: 'row',
          padding: 1,

          '& .counting-info': {
            display: 'block',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',

            fontStyle: 'normal',
            fontWeight: 400,
            fontSize: 12,
            lineHeight: '15px',
            textAlign: 'right',
            // color: palette.neutralPrimary,

            position: 'relative',
            top: 2,

            '& .empty-desc': {
              marginLeft: 12,
            },
          },
        },
      },
    },

    '& .grid-cell-with-accessory': {
      paddingRight: 54,
    },

    '& .folder-cell-accessory': {
      position: 'absolute',
      top: 0,
      bottom: 0,
      right: 0,
      width: 42,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },

    '& .folder-grid-loading-cell-content': {
      height: '100%',
    },
  },

  selectableCellCard: {
    background: 'white',
  },

  folderCellNewLabel: {
    display: 'flex',
    alignItems: 'center',

    '& div.label-icon-and-text': {
      padding: [2, 8, 2, 6],
    },

    '& .label-secondary-text': {
      width: 0,
    },

    '&:hover': {
      '& .label-secondary-text': {
        width: '100%',
        opacity: 1,
        transform: 'translate(10px, 0px)',
        color: palette.neutralPrimary,
      },
    },
  },
});
